import AuthContentWrapper from "./components/AuthContentWrapper";
import { C2Text, T1Text } from "../../common/components/text/CustomText";
import { Column, SizedBox } from "../../common/components/CommonBaseComponents";
import { useSearchParams } from "react-router-dom";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import { Theme } from "../../common/Theme";
import { useEffect, useState } from "react";
import LocalStorageKey from "../../common/enums/LocalStorageKey";
import LMPAuthUtils from "../../api/lmp/LMPAuthUtils";

function RoleMessagePage() {
    const [searchParams] = useSearchParams();
    const title = searchParams.get("title");
    const [content, setContent] = useState("");

    function handleGoToLogin() {
        const serverCountry = localStorage.getItem(LocalStorageKey.server) || "TH";
        window.location.href = LMPAuthUtils.getLoginUrl({ serverCountry });
    }

    useEffect(() => {
        if (title === "Sign in unavailable") {
            setContent("Your account is awaiting admin approval.You’ll receive an email once it’s approved.");
        } else if (title === "Role Approval Rejected") {
            setContent(
                "Your account request has been rejected by the admin. Please contact your administrator for more information."
            );
        }
    }, [title]);

    return (
        <AuthContentWrapper contentPadding={"62px 60px"}>
            <Column justifyContent={"center"}>
                <T1Text letterSpacing={"-0.56px"} fontWeight={"500"} fontColor={Theme.color.zinc900}>
                    {title}
                </T1Text>
                <SizedBox height={"20px"} />
                <C2Text fontColor={Theme.color.neutral500} textAlign={"center"}>
                    {content}
                </C2Text>
                <SizedBox height={"32px"} />
                <FullWidthButton onClick={handleGoToLogin} text={"Ok"} />
                <SizedBox height={"12px"} />
            </Column>
        </AuthContentWrapper>
    );
}

export default RoleMessagePage;
